<div class="sidebar included">
	<app-sidebar-header [title]="'Full refund'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flight"></app-flight-route>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">Full refund per passenger</h2>
			<div class="border sidebar-flight-text" *ngFor="let passenger of booking.passengers_info">
				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{TAP_printName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg><span class="bold">Full Refund</span> included in <span
							class="capitalize">{{TAP_printBrand()}}</span>.
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<h2 class="title-h2">Cancellation rulles</h2>
			<div class="grid">
				<div class="col-12">
					<ul>
						<li>Flammables, such as paint, white spirits, paraffin, and fire-lighter cubes for starting
							charcoal fires
							(barbecues);</li>
						<li>Explosives, such as fireworks; Corrosives, including cleaning products, chemical unblocking
							agents, ammonia
							and batteries filled with battery acid;</li>
						<li>Poisons, such as mouse or rat poison, insecticide and cockroach spray;</li>
						<li>Pressurized containers: cylinders of camping gas, filled oxygen cylinders for diving, but
							also fire
							extinguishers.</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<p><a class="link extras-feature__link" aria-label="Close dialog" (click)="TAP_handleClose()" href="javascript:;" role="button">Close this
					window</a></p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
